import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationCircleFillMini = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.5999 11.9999C21.5999 17.3018 17.3018 21.5999 11.9999 21.5999C6.69797 21.5999 2.3999 17.3018 2.3999 11.9999C2.3999 6.69797 6.69797 2.3999 11.9999 2.3999C17.3018 2.3999 21.5999 6.69797 21.5999 11.9999ZM11.9999 5.9999C12.497 5.9999 12.8999 6.40285 12.8999 6.8999V12.2999C12.8999 12.797 12.497 13.1999 11.9999 13.1999C11.5028 13.1999 11.0999 12.797 11.0999 12.2999V6.8999C11.0999 6.40285 11.5028 5.9999 11.9999 5.9999ZM11.9999 17.9999C12.6626 17.9999 13.1999 17.4626 13.1999 16.7999C13.1999 16.1372 12.6626 15.5999 11.9999 15.5999C11.3372 15.5999 10.7999 16.1372 10.7999 16.7999C10.7999 17.4626 11.3372 17.9999 11.9999 17.9999Z",
		fill: "currentcolor"
	})]
});
export default SvgExclamationCircleFillMini;
